<template>
  <div class="msg-notification-page">
    <MsgNotification
      :webinar-id="webinarId"
      :lang="$i18n.locale"
      v-if="permissionValue.message_notice == 1"
      :env="env"
    />
    <WechatNotification :webinar-id="webinarId"></WechatNotification>
    <begin-play
      :webinarId="$route.params.str"
      v-if="$route.query.type != 5 && webinarState != 4"
    ></begin-play>
  </div>
</template>

<script>
  import { MsgNotification } from '@vhcl/msg-notification';
  import WechatNotification from './WeChatNotification';
  import { sessionOrLocal } from '@/utils/utils';
  import beginPlay from '@/components/beginBtn';
  export default {
    name: 'MsgNotificationContainer',
    components: {
      MsgNotification,
      WechatNotification,
      beginPlay
    },
    computed: {
      permissionValue() {
        return this.$store.state.permissionValue;
      }
    },
    data() {
      return {
        webinarId: this.$route.params.str, // 活动id
        env: process.env.VUE_APP_ENV_HCL, // 运行时环境判断后端接口
        webinarState: JSON.parse(sessionOrLocal.get('webinarState'))
      };
    },
    mounted() {
      console.log('this.$i18n.locale:', this.$i18n.locale);
    }
  };
</script>
<style scoped lang="less">
  .msg-notification-page {
    ::v-deep(.msg-notification-page) {
      .list-content {
        min-height: auto;
      }
      .msg-notification__body {
        padding-bottom: 0;
      }
    }
  }
</style>
